export default __webpack_public_path__ + "static/media/journal-2-slideout.dfbc07b2.jpg";